import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"currentColor\" clip-path=\"url(#broadcast-clip0_2961_552)\"><path fill-rule=\"evenodd\" d=\"M7.184 2.294a1.326 1.326 0 0 0 0 2.651 11.93 11.93 0 0 1 11.93 11.93 1.326 1.326 0 1 0 2.651 0A14.583 14.583 0 0 0 7.185 2.294m0 6.618a1.326 1.326 0 1 0 0 2.652 5.303 5.303 0 0 1 5.302 5.302 1.326 1.326 0 0 0 2.652 0 7.954 7.954 0 0 0-7.954-7.954\" clip-rule=\"evenodd\"></path><circle cx=\"5\" cy=\"19\" r=\"2\"></circle></g><defs><clipPath id=\"broadcast-clip0_2961_552\"><path fill=\"currentColor\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
  ]))]))
}
export default { render: render }